const mod = require('../../bahabot.module.js')
mod.component('bbInput', {
    templateUrl: 'tpl/ui/bb-input.component.html',
    bindings: {
        variant: '@?',
        profile: '@?',
        container: '@?',

        name: '@',
        label: '@',
        placeholder: '@',
        type: '@?',
        required: '@',

        ngRequired: '<',
        ngMinlength: '<',
        ngMaxlength: '<',
        ngPattern: '<',

        invalidIf: '<'
    },
    require: {
        // links to the ng-model on the tag
        ngModelCtrl: 'ngModel',
        formCtrl: '?^form'
    },

    controller: [function bbInputController() {  
        this.$onInit = function() {
            if (!this.type) this.type = 'text';
            if (!this.variant) this.variant = 'light';
            if (!this.profile) this.profile = 'standard';
            if (!this.container) this.container = 'mb-4';

            this.ngModelCtrl.$render = () => {
                this.innerValue = this.ngModelCtrl.$viewValue;
            };
        };

        this.updateModel = function() {
            this.ngModelCtrl.$setViewValue(this.innerValue);
        };
        
        this.onBlur = function() {
            this.ngModelCtrl.$setTouched();
        };
    }]
});